import React from 'react';
import simbolo from '../../assets/marca/tornado-simbolo.svg?raw';
import simboloSimple from '../../assets/marca/tornado-simbolo-simple.svg?raw';
import completo from '../../assets/marca/tornado-completo.svg?raw';

// Los SVG salen de branding/ vía scripts/generar-marca.mjs; se insertan en
// línea (no como <img>) para que tomen el color del texto con currentColor.
const MARCAS = {
    simbolo,
    simple: simboloSimple,
    completo
};

const aLaMedida = (svg) => svg.replace('<svg ', '<svg width="100%" height="100%" aria-hidden="true" focusable="false" ');
const LISTAS = Object.fromEntries(Object.entries(MARCAS).map(([k, v]) => [k, aLaMedida(v)]));

/**
 * Marca de Tornado Digital.
 *
 * variante="simbolo" es el símbolo tal cual; "simple" es sólo el anillo, para
 * cuando se dibuja por debajo de ~28px y los puntos del borde se empastan;
 * "completo" lleva además el nombre. El color lo da la clase (text-*).
 */
const Logo = ({ variante = 'simbolo', className = '', titulo = 'Tornado Digital' }) => (
    <span
        role="img"
        aria-label={titulo}
        className={`inline-flex shrink-0 ${className}`}
        dangerouslySetInnerHTML={{ __html: LISTAS[variante] ?? LISTAS.simbolo }}
    />
);

export default Logo;
